/* eslint-disable react/react-in-jsx-scope */
import type { AppTheme } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  ThemeBlueprint,
} from '@backstage/plugin-app-react';
import { createCerebroSignInPage } from './cerebroSignInPage';
import { customThemes } from '../../themes';

const cerebroSignIn = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const { SignInPage } = await import('@backstage/core-components');
      return createCerebroSignInPage(SignInPage);
    },
  },
});

const cerebroThemes = customThemes.map(theme =>
  ThemeBlueprint.make({
    name: theme.id,
    params: { theme: theme as AppTheme },
  }),
);

export const cerebroAppModule = createFrontendModule({
  pluginId: 'app',
  extensions: [cerebroSignIn, ...cerebroThemes],
});
